import { FAKE_TEXT } from "helpers/constants";

export const COMPETENCY_REQUIREMENTS = [
  {
    reqId: "COMP1.1",
    requirementName: "Analgesic Plan - Assess Pain and Devise Plan",
    fullDescription: FAKE_TEXT.MEDIUM,
    requirementType: "Binary Completion",
    targetSkillLevel: null,
    currentSkillLevel: null,
    completed: false,
    animalSize: "Small",
    specificSpecies: "Canine",
    performanceMinimum: 4,
    minimumScoreToAchieve: 3,
    totalAttempts: 2,
    additionalResources: [
      {
        id: "res-1",
        name: "Resource 1",
        url: "https://www.google.com",
      },
      {
        id: "res-2",
        name: "Resource 2",
        url: "https://www.google.com",
      },
      {
        id: "res-3",
        name: "Resource 3",
        url: "https://www.google.com",
      },
    ],
  },
  {
    reqId: "COMP1.2",
    requirementName: "Complete blood Count (CBC) - Interpret",
    fullDescription: FAKE_TEXT.MEDIUM,
    requirementType: "Performance-Based",
    targetSkillLevel: 5,
    currentSkillLevel: 2,
    completed: false,
    animalSize: "Small",
    specificSpecies: "Canine",
    performanceMinimum: 4,
    minimumScoreToAchieve: 3,
    totalAttempts: 2,
    additionalResources: [
      {
        id: "res-1",
        name: "Resource 1",
        url: "https://www.google.com",
      },
      {
        id: "res-2",
        name: "Resource 2",
        url: "https://www.google.com",
      },
    ],
  },
  {
    reqId: "COMP1.3",
    requirementName: "Appropriate analgesic plan - Assess Pain and Devise",
    fullDescription: FAKE_TEXT.MEDIUM,
    requirementType: "Performance-Based",
    targetSkillLevel: 5,
    currentSkillLevel: 2,
    completed: false,
    animalSize: "Small",
    specificSpecies: "Canine",
    performanceMinimum: 4,
    minimumScoreToAchieve: 3,
    totalAttempts: 2,
    additionalResources: [],
  },
  {
    reqId: "COMP1.4",
    requirementName: "Complete blood Count (CBC) - Interpret 2",
    fullDescription: FAKE_TEXT.MEDIUM,
    requirementType: "Performance-Based",
    targetSkillLevel: 5,
    currentSkillLevel: null,
    completed: false,
    animalSize: "Small",
    specificSpecies: "Canine",
    performanceMinimum: 4,
    minimumScoreToAchieve: 3,
    totalAttempts: 2,
    additionalResources: [],
  },
  {
    reqId: "COMP1.5",
    requirementName: "Appropriate analgesic plan - Assess Pain and Devise 2",
    fullDescription: FAKE_TEXT.MEDIUM,
    requirementType: "Performance-Based",
    targetSkillLevel: 5,
    currentSkillLevel: null,
    completed: false,
    animalSize: "Small",
    specificSpecies: "Canine",
    performanceMinimum: 4,
    minimumScoreToAchieve: 3,
    totalAttempts: 2,
    additionalResources: [],
  },
  {
    reqId: "COMP1.6",
    requirementName: "Analgesic Plan - Assess Pain and Devise Plan 6",
    fullDescription: FAKE_TEXT.MEDIUM,
    requirementType: "Performance-Based",
    targetSkillLevel: 5,
    currentSkillLevel: null,
    completed: false,
    animalSize: "Small",
    specificSpecies: "Canine",
    performanceMinimum: 4,
    minimumScoreToAchieve: 3,
    totalAttempts: 2,
    additionalResources: [],
  },
  {
    reqId: "COMP2.1",
    requirementName: "Analgesic Plan - Assess Pain and Devise Plan 1",
    fullDescription: FAKE_TEXT.MEDIUM,
    requirementType: "Performance-Based",
    targetSkillLevel: 5,
    currentSkillLevel: null,
    completed: false,
    animalSize: "Small",
    specificSpecies: "Canine",
    performanceMinimum: 4,
    minimumScoreToAchieve: 3,
    totalAttempts: 2,
    additionalResources: [],
  },
  {
    reqId: "COMP2.2",
    requirementName: "Appropriate analgesic plan - Assess Pain and Devise 2.2",
    fullDescription: FAKE_TEXT.MEDIUM,
    requirementType: "Performance-Based",
    targetSkillLevel: 5,
    currentSkillLevel: null,
    completed: false,
    animalSize: "Small",
    specificSpecies: "Canine",
    performanceMinimum: 4,
    minimumScoreToAchieve: 3,
    totalAttempts: 2,
    additionalResources: [],
  },
  {
    reqId: "COMP2.3",
    requirementName: "Analgesic Plan - Assess Pain and Devise Plan",
    fullDescription: FAKE_TEXT.MEDIUM,
    requirementType: "Performance-Based",
    targetSkillLevel: 5,
    currentSkillLevel: null,
    completed: false,
    animalSize: "Small",
    specificSpecies: "Canine",
    performanceMinimum: 4,
    minimumScoreToAchieve: 3,
    totalAttempts: 2,
    additionalResources: [],
  },
  {
    reqId: "COMP2.4",
    requirementName: "Analgesic Plan - Assess Pain and Devise Plan",
    fullDescription: FAKE_TEXT.MEDIUM,
    requirementType: "Performance-Based",
    targetSkillLevel: 5,
    currentSkillLevel: null,
    completed: false,
    animalSize: "Small",
    specificSpecies: "Canine",
    performanceMinimum: 4,
    minimumScoreToAchieve: 3,
    totalAttempts: 2,
    additionalResources: [],
  },
];
